// The admin scheduler's form, kept in the tab while an advisor fills it in
// (Taylor Vinton, 2026-10-29: the tab left /schedule mid-call and came back
// empty, because the form only lived in the page). sessionStorage, so it is
// this tab's alone and goes when the tab closes.

export const DRAFT_KEY = 'flow-scheduler-draft'

// A draft older than this is an abandoned call, not one to pick back up.
export const DRAFT_MAX_AGE = 2 * 60 * 60 * 1000

function tabStorage (storage) {
    if (storage !== undefined) return storage
    return typeof window !== 'undefined' ? window.sessionStorage : null
}

export function saveDraft ({ userId, path, data }, { storage, now = Date.now } = {}) {
    try {
        tabStorage(storage).setItem(DRAFT_KEY, JSON.stringify({ userId, path, savedAt: now(), data }))
        return true
    } catch (e) {
        return false
    }
}

export function clearDraft ({ storage } = {}) {
    try {
        tabStorage(storage).removeItem(DRAFT_KEY)
    } catch (e) {
        // Nothing stored, nothing to clear.
    }
}

// The draft this page may pick up: the same signed-in user, the same URL, and
// recent. Another user's or a stale one is thrown away; one for another URL is
// left for when they go back to it.
export function loadDraft ({ userId, path }, { storage, now = Date.now } = {}) {
    let draft
    try {
        draft = JSON.parse(tabStorage(storage).getItem(DRAFT_KEY) || 'null')
    } catch (e) {
        return null
    }
    if (!draft) return null
    if (draft.userId !== userId || !(now() - draft.savedAt <= DRAFT_MAX_AGE)) {
        clearDraft({ storage })
        return null
    }
    return draft.path === path ? draft : null
}
